import {
  CreateInDialogButtonProps,
  CreateInDialogButton as CreateInDialogButtonRa,
} from '@react-admin/ra-form-layout';
import { ResourceContextProvider } from 'react-admin';

import { useCanAccess } from '@sh4res/bo-common/hooks';
import { disableBackdropClose, Resources } from '@sh4res/bo-common/utils';

export const CreateInDialogButton = ({
  resource,
  testId,
  ...props
}: CreateInDialogButtonProps & { resource: Resources; testId?: string }) => {
  const canAccess = useCanAccess({
    resource,
    action: 'create',
  });

  return canAccess ? (
    <ResourceContextProvider value={resource}>
      <CreateInDialogButtonRa
        {...props}
        onClose={disableBackdropClose}
        ButtonProps={{
          ...props.ButtonProps,
          ...(testId !== undefined && { 'data-testid': testId }),
        }}
      />
    </ResourceContextProvider>
  ) : null;
};
